import { render, staticRenderFns } from "./inspectaddorupdate.vue?vue&type=template&id=7af166f0"
import script from "./inspectaddorupdate.vue?vue&type=script&lang=js"
export * from "./inspectaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports